<script setup lang="ts">

//vue
import { onMounted, reactive, } from "vue";

//servicos
import * as service from "@/services/BoletosService";
import { fdataHora } from "@/utils/funcoes";

//componentes
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import Loading from "@/components/Loading/index.vue"
import RetornoStatus from "./RetornoStatus.vue"
import Pergunta from "@/components/Pergunta/Index.vue"
import DropdownParamBoleto from "@/components/Dropdowns/DropdownParamBoleto.vue"
import Paginador from "@/components/Paginador/Index.vue"
import ImportarRetorno from "./ImportarRetorno.vue"

var controle = reactive({
    filtros: {
        paginaAtual: 1,
        tamanhoPagina: 50
    } as service.BoletoRetornosFiltros,
    retornos: [] as service.BoletoRetorno[],
    retornoId: 0 as number,
    retorno: {} as service.BoletoRetorno,
    ordemDirecao: "Desc",
    ordemColuna: "RetornoId",
    totalRegistros: 0,

    pesquisando: false,
    loading: false,
    status: "",
    erro: "",

    // Estados do diálogo de confirmação
    showConfirmDialog: false,
    processandoRetorno: false,
    retornoParaProcessar: null as service.BoletoRetorno | null,

    janImportarRetorno: false,

});


onMounted(() => {
    pesquisar();
})


const pesquisar = async () => {

    controle.erro = "";
    controle.pesquisando = true;
    controle.status = "Pesquisando...";
    controle.retornos = [] as service.BoletoRetorno[];
    controle.totalRegistros = 0;

    if (controle.filtros.dataCadIni == "")
        controle.filtros.dataCadIni = null;

    if (controle.filtros.dataCadFin == "")
        controle.filtros.dataCadFin = null;

    service.obterRetornos(controle.filtros)
        .then((r) => {
            controle.pesquisando = false;
            controle.status = "";
            controle.retornos = r.dados;
            controle.totalRegistros = r.totalRegistros;
        })
        .catch((erro: string) => {
            controle.pesquisando = false;
            controle.erro = erro;
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};



const ordenarPor = (coluna: string) => {
    if (controle.ordemColuna == coluna) {
        if (controle.ordemDirecao == "asc")
            controle.ordemDirecao = "desc";
        else
            controle.ordemDirecao = "asc";
    }
    else
        controle.ordemDirecao = "asc";

    controle.ordemColuna = coluna;

    if (controle.ordemDirecao == "asc")
        controle.retornos = controle.retornos.sort((a, b) => (a[coluna] > b[coluna]) ? 1 : ((b[coluna] > a[coluna]) ? -1 : 0));
    else
        controle.retornos = controle.retornos.sort((a, b) => (a[coluna] < b[coluna]) ? 1 : ((b[coluna] < a[coluna]) ? -1 : 0));
}

// Função para mostrar confirmação antes de processar retorno
function perguntaProcessar(retorno: service.BoletoRetorno) {
    controle.retornoParaProcessar = retorno;
    controle.showConfirmDialog = true;
}

// Função chamada quando o usuário responde ao diálogo
function confirmaProcessar(confirmou: boolean) {
    controle.showConfirmDialog = false;

    if (confirmou && controle.retornoParaProcessar) {
        processarRetorno(controle.retornoParaProcessar);
    }

    controle.retornoParaProcessar = null;
}

// Função para processar o retorno
async function processarRetorno(retorno: service.BoletoRetorno) {
    try {
        controle.loading = true;
        controle.processandoRetorno = true;
        controle.status = "Processando retorno...";

        // Aqui você chamaria o serviço para processar o retorno
        await service.processarRetorno(retorno.retornoId);

        // Simular processamento por 2 segundos
        await new Promise(resolve => setTimeout(resolve, 2000));

        controle.status = "Retorno processado com sucesso!";

        pesquisar();

        setTimeout(() => {
            controle.loading = false;
            controle.processandoRetorno = false;
        }, 3000);


    } catch (erro) {
        controle.erro = `Erro ao processar retorno: ${erro}`;
    } finally {
        controle.processandoRetorno = false;
        setTimeout(() => {
            controle.status = "";
            controle.loading = false;
        }, 3000);
    }
}

</script>

<template>
    <NavBarStatus :erro="controle.erro" @limparErro="controle.erro = ''" />

    <Loading :isLoading="controle.loading" :mensagem="controle.status" />

    <BreadCrumb PageTitle="Retornos" :items="[{label: 'Inicio', to: '/'}, {label: 'Boletos', to: '/boletos'}, {label: 'Retornos', to: '/retornos'}]" />

    <div class="card">
        <div class="card-body">
         

            <div class="row mb-2">
                <div class="col-md-4 col-12">
                    <label>Convênio</label>
                    <DropdownParamBoleto v-model="controle.filtros.paramBoletoId" id="inputFocus" @change="pesquisar()" />
                </div>

                <div class="col-md-2 col-12">
                    <label>Data Inicial</label>
                    <input v-model="controle.filtros.dataCadIni" type="date" class="form-control form-control-sm"
                        @change="pesquisar()" />
                </div>

                <div class="col-md-2 col-12">
                    <label>Data Final</label>
                    <input v-model="controle.filtros.dataCadFin" type="date" class="form-control form-control-sm"
                        @change="pesquisar()" />
                </div>

                <div class="col-md-2 col-12">
                    <label>Status</label>

                    <select v-model="controle.filtros.status" class="form-select form-select-sm" @change="pesquisar()">
                        <option :value="null">- Todos -</option>
                        <option :value="0">Pendente</option>
                        <option :value="1">Em Processamento</option>
                        <option :value="2">Concluído</option>
                        <option :value="3">Erro</option>
                    </select>
                </div>

                <div class="col-md-2 col-12">
                    <a class="btn btn-primary btn-sm mt-3" @click="pesquisar()">
                        <i class="fa fa-search"></i> Pesquisar
                    </a>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 div-table-retornos">
                    <table class="table table-striped table-hover table-sm table-bordered">
                        <thead class="th-fixed">
                            <tr>
                                <th class="text-end">Retorno</th>
                                <th class="text-center">Data</th>
                                <th class="text-start">Cedente</th>
                                <th class="text-start">Cnpj</th>
                                <th class="text-end">Número</th>
                                <th class="text-end">Nº arquivo</th>
                                <th class="text-end">Qtde itens</th>
                                <th class="text-center">Status</th>
                                <th class="text-center">Opções</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-show="controle.pesquisando == true">
                                <td colspan="15" class="text-center">
                                    <div class="d-inline">
                                        <i class="fa fa-cog fa-spin"></i>
                                        Pesquisando...
                                    </div>
                                </td>
                            </tr>

                            <tr class="col-md-12 text-center table-danger" v-show="controle.erro != ''">
                                <td colspan="15" class="text-center">
                                    <div class="d-inline">
                                        <i class="fa fa-exclamation"></i>
                                        {{ controle.erro }}
                                    </div>
                                    <a class="btn btn-primary btn-sm" @click="pesquisar()">Repetir</a>
                                </td>
                            </tr>

                            <tr v-for="(item, idx) in controle.retornos" :key="idx"
                                :class="item.retornoId == controle.retornoId ? 'table-active' : ''"
                                @click="controle.retornoId = item.retornoId; controle.retorno = item">

                                <td class="text-end">{{ item.retornoId }}</td>
                                <td class="text-center">{{ fdataHora(item.dataCadastro) }}</td>
                                <td class="text-start">{{ item.cedenteCodigo }}</td>
                                <td class="text-start">{{ item.cedenteCpfCnpj }}</td>
                                <td class="text-end">{{ item.numero }}</td>
                                <td class="text-end">{{ item.numeroArquivo }}</td>
                                <td class="text-end">{{ item.qtdeItens }}</td>
                                <td class="text-center">
                                    <RetornoStatus :status="item.status" />
                                </td>

                                <td class="text-center" data-label="Opções">
                                    <RouterLink class="btn btn-sm  btn-primary me-1"
                                        :to="'/boletosRetornosItens/' + item.retornoId"
                                        title="Exibir detalhes do retorno">
                                        <i class="fa fa-search"></i>
                                    </RouterLink>

                                    <a class="btn btn-sm  btn-warning me-1" title="Processar retorno"
                                        href="javascript:void(0)" v-if="item.status != 2"
                                        @click="perguntaProcessar(item)" :disabled="controle.processandoRetorno">
                                        <i class="fa fa-play"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col-md-8">
                    <a class="btn btn-sm btn-primary me-2" @click="controle.janImportarRetorno = true"
                        title="Importar arquivo de retorno do banco">
                        <i class="fa fa-download"></i> Importar Retorno
                    </a>
                    <span class="text-muted">Total: {{ controle.totalRegistros }} registro(s)</span>
                </div>
                <div class="col-md-3">
                    <Paginador class="float-end" :paginaAtual="controle.filtros.paginaAtual"
                        :tamanhoPagina="controle.filtros.tamanhoPagina" :totalRegistros="controle.totalRegistros"
                        @on-change="(el) => {
                            controle.filtros.paginaAtual = el.paginaAtual;
                            controle.filtros.tamanhoPagina = el.tamanhoPagina;
                            pesquisar()
                        }" />
                </div>
                <div class="col-md-1">
                    <RouterLink class="btn btn-sm btn-primary me-1 float-end" to="/boletos" title="Fechar">
                        Fechar
                    </RouterLink>
                </div>
            </div>
        </div>
    </div>

    <!-- Diálogo de Confirmação -->
    <Pergunta :exibir="controle.showConfirmDialog" titulo="Processar Retorno"
        :mensagem="`Deseja processar o retorno ${controle.retornoParaProcessar?.retornoId}?`"
        :detalhes="controle.retornoParaProcessar ? `Arquivo: ${controle.retornoParaProcessar.numero} | Itens: ${controle.retornoParaProcessar.qtdeItens}` : ''"
        tipo="warning" textoSim="Processar" textoNao="Cancelar" :processando="controle.processandoRetorno"
        @resposta="confirmaProcessar" />

    <ImportarRetorno :exibir="controle.janImportarRetorno" @fechou="controle.janImportarRetorno = false"
        @importou="pesquisar()" />

</template>

<style scoped>
.div-table-retornos {
    max-height: calc(100vh - 255px);
    min-height: calc(100vh - 255px);
    overflow: auto;
}

</style>